import React, { useEffect, useState } from 'react';

import { CaixaEntradaProcessos, CaixaEntradaProps, GetAllCaixaEntrada } from '@app/api/naoPrevistos/caixaEntrada';
import { getLoggedId } from '@app/helpers';
import {
  GridView,
  SimpleView,
  Widget,
  Table,
  ColumnProps,
  Button
} from '@digital/ui';
import { Tooltip, Icon } from 'antd';
import { compareText } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';


const CaixaEntrada = () => {
  const [filterResponsavel, setFilterResponsavel] = useState<any[]>();
  const [data, setData] = useState<CaixaEntradaProps[]>();

  const userId = getLoggedId();


  useEffect(() => {
    GetAllCaixaEntrada().then((data: CaixaEntradaProps[] | undefined) => {
      if (data) {
        setData(data);
      }
    })
  }, []);

  const handleRedirect = (link: string) => {
    document.location.href = link;
  };

  const columns: ColumnProps<CaixaEntradaProps>[] = [
    // {
    //   title: 'Processo',
    //   dataIndex: 'processo',
    //   sorter: (a, b) => compareText(a.processo, b.processo),
    //   width: '10%',
    //   filters: CaixaEntradaProcessos || [],
    //   filterMultiple: true,
    //   filterIcon: filtered => <Icon type="filter" style={{ minWidth: 'auto', border: 'none' }} />,
    //   onFilter: (value, record) => record.processo.indexOf(value) === 0,
    // },
    {
      title: 'Atividade',
      dataIndex: 'atividade',
      sorter: (a, b) => compareText(a.atividade, b.atividade),
      width: '25%',
      ...mountFormFilterDropDown('atividade', 'Pesquisar'),
    },
    {
      title: 'Projeto',
      dataIndex: 'projeto',
      sorter: (a, b) => compareText(a.projeto, b.projeto),
      width: '5%',
      ...mountFormFilterDropDown('projeto', 'Pesquisar'),
    },

    {
      title: 'Responsável',
      dataIndex: 'solicitante',
      sorter: (a, b) => compareText(a.solicitante, b.solicitante),
      width: '25%',
      filteredValue: filterResponsavel,
      ...mountFormFilterDropDown('solicitante', 'Pesquisar'),
    },
    {
      title: 'Ações',
      dataIndex: 'acao',
      render: (index, item) => {
        return (
          <Tooltip title="Executar Atividade">
            <Button
              type="link"
              icon="arrows-circled_right_2"
              size="small"
              onClick={() => {
                handleRedirect(`solicitacao/${item.solicitacaoNaoPrevistoId}`);
              }}
            />
          </Tooltip>
        );
      },
      width: '5%',
    },
  ];

  return (
    <SimpleView>
      <GridView>
        <Widget title="Lista de atividades pendentes">
          <Table
            rowKey="rowId"
            columns={columns}
            dataSource={data}
          />
        </Widget>
      </GridView>
    </SimpleView>
  );
};

export default CaixaEntrada;
